var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nav',{attrs:{"isActive":"2","isIndex":_vm.isIndex}}),_vm._v(" "),_c('div',{staticClass:"p100 pageWD",staticStyle:{"height":"500px"}},[_vm._v("\n    课程师资课程师资\n  ")]),_vm._v(" "),_c('Fotter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68bd85f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/kcsz/index.vue
// module id = null
// module chunks = 